import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";
import { getAnalytics, Analytics } from "firebase/analytics";

// Firebase configuration for Chip AI Studio
const firebaseConfig = {
  apiKey: "AIzaSyDxYdrTJQPZkP3Q43KIoiJby6EW3zrBT1E",
  authDomain: "chip-ai-studio.firebaseapp.com",
  projectId: "chip-ai-studio",
  storageBucket: "chip-ai-studio.firebasestorage.app",
  messagingSenderId: "541376687784",
  appId: "1:541376687784:web:7649c05d8bfe2fe4b55c9d",
  measurementId: "G-N4EXX12KLY"
};

// Application is now configured with valid keys
export const isConfigured = true;

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let db: Firestore | undefined;
let storage: FirebaseStorage | undefined;
let analytics: Analytics | undefined;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.error("Firebase initialization failed:", error);
}

export const googleProvider = new GoogleAuthProvider();
export { app, auth, db, storage, analytics };